import React from "react";
import PropTypes from "prop-types";

// Per-line controls, tucked at the end of the lyric.
//
// Deliberately quiet: they sit at low opacity until the line is the one playing
// or the pointer is over it (see the stylesheet). This page is mostly watched
// rather than used, and three buttons on every visible line, at full strength,
// would compete with the lyric they're attached to.
//
// On touch, where there is no hover, they stay visible - there's no way to
// discover them otherwise.

function IconAdd() {
  return (
    <svg aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2"
      viewBox="0 0 24 24">
      <path d="M12 5v14M5 12h14" strokeLinecap="round" />
    </svg>
  );
}

function IconPlayFrom() {
  return (
    <svg aria-hidden="true" fill="currentColor" viewBox="0 0 24 24">
      <path d="M8 5.2v13.6a1 1 0 0 0 1.53.85l10.6-6.8a1 1 0 0 0 0-1.7L9.53 4.35A1 1 0 0 0 8 5.2Z" />
      <rect height="15" rx="1" width="2.2" x="3.4"
        y="4.5" />
    </svg>
  );
}

export default function LineActions({ line, onAdd, onPlayFrom }) {
  return (
    <div className="ir-line-actions">
      <button
        aria-label="Add this line to a collection"
        className="ir-line-action"
        onClick={() => onAdd(line)}
        title="Add to collection"
        type="button"
      >
        <IconAdd />
      </button>

      <button
        aria-label="Play from this line"
        className="ir-line-action"
        onClick={() => onPlayFrom(line)}
        title="Play from here"
        type="button"
      >
        <IconPlayFrom />
      </button>

    </div>
  );
}

LineActions.propTypes = {
  line: PropTypes.object.isRequired,
  onAdd: PropTypes.func.isRequired,
  onPlayFrom: PropTypes.func.isRequired,
};
